import { FC, Fragment } from 'react';
import { KaizenChartForHooks } from '@kaizenplatform/kaizen-chartjs';
import { Chart } from '@kaizenplatform/kaizen-chartjs';
import GlobalPeriod from '../../../../entity/GlobalPeriod';
import { IChart as LiftReportChart } from '../../../../entity/Chart';
import styled from '@emotion/styled';
import Loading from '../Loading';
import useKaizenChart from '../../../../hooks/useKaizenChart';
import { PaperContent, PaperItem, PaperText, PaperTitle, PaperTitleText, StyledPaper } from '../../primitive/Paper';

type Props = {
  liftReportIndex?: LiftReportChart;
  liftReportCoverage?: LiftReportChart;
  goalId: string | null;
  liftReportLoading: boolean;
  liftReportChartSetting: GlobalPeriod;
};

const IndexReport: FC<Props> = ({
  liftReportIndex,
  liftReportCoverage,
  goalId,
  liftReportLoading,
  liftReportChartSetting,
}) => {
  const {
    chartData: coverageChartData,
    frequencyData: coverageFrequencyData,
    initialFrequency: initialCoverageFrequency,
    frequencyLoading: coverageFrequencyLoading,
    chartLoading: coverageChartLoading,
    refetch: refetchCoverage,
  } = useKaizenChart(liftReportChartSetting, goalId, liftReportCoverage);
  const {
    chartData: indexChartData,
    frequencyData: indexFrequencyData,
    initialFrequency: initialIndexFrequency,
    frequencyLoading: indexFrequencyLoading,
    chartLoading: indexChartLoading,
    refetch: refetchIndex,
  } = useKaizenChart(liftReportChartSetting, goalId, liftReportIndex);

  return (
    <Fragment>
      <StyledPaper>
        <PaperTitle>
          <PaperTitleText>実績CV数と改善率</PaperTitleText>
        </PaperTitle>
        <PaperContent>
          <PaperItem>
            <PaperText>
              サイト全体でどういう変化が起こっているかを、様々な指標のトレンドから確認することができます。
            </PaperText>
          </PaperItem>
          <PaperItem>
            {liftReportLoading ? (
              <LoadingContainer>
                <Loading />
              </LoadingContainer>
            ) : (
              <KaizenChartForHooks
                chartData={coverageChartData ? ((coverageChartData as any).chart as Chart) : undefined}
                identifier={{ id: liftReportCoverage ? liftReportCoverage.id : '' }}
                scope={{
                  from: liftReportChartSetting.from.toISO(),
                  to: liftReportChartSetting.to.toISO(),
                  frequency: initialCoverageFrequency,
                }}
                loading={liftReportLoading || coverageFrequencyLoading || coverageChartLoading}
                refetch={refetchCoverage}
                frequencies={
                  (coverageFrequencyData as any)
                    ? ((coverageFrequencyData as any).chart as Chart).frequencies
                    : undefined
                }
              />
            )}
          </PaperItem>
        </PaperContent>
      </StyledPaper>
      <StyledPaper>
        <PaperTitle>
          <PaperTitleText>セッション数とCVR</PaperTitleText>
        </PaperTitle>
        <PaperContent>
          <PaperItem>
            {liftReportLoading ? (
              <LoadingContainer>
                <Loading />
              </LoadingContainer>
            ) : (
              <KaizenChartForHooks
                chartData={indexChartData ? ((indexChartData as any).chart as Chart) : undefined}
                identifier={{ id: liftReportIndex ? liftReportIndex.id : '' }}
                scope={{
                  from: liftReportChartSetting.from.toISO(),
                  to: liftReportChartSetting.to.toISO(),
                  frequency: initialIndexFrequency,
                }}
                loading={liftReportLoading || indexFrequencyLoading || indexChartLoading}
                refetch={refetchIndex}
                frequencies={
                  (indexFrequencyData as any) ? ((indexFrequencyData as any).chart as Chart).frequencies : undefined
                }
              />
            )}
          </PaperItem>
        </PaperContent>
      </StyledPaper>
    </Fragment>
  );
};

const LoadingContainer = styled('div')({
  margin: '0px 24px',
  height: '600px',
});

export default IndexReport;
